const routePaths = Object.freeze({
  homepage: "/",
  illustrations: "/illustrations",
  illustrationImageUsageReport: "/illustration-image-usage-report",
  logs: "/logs",
  whitelistedIssuers: "/whitelisted-issuers",
  managePatientIssuers: "/manage-patient-issuers",
  verifyTwoFa: "/verify-two-fa",
  enableTwoFa: "/enable-two-fa",
  login: "/login",
  illustrationMappings: "/illustration-mappings",
  clinicalQA: "/clinical-quality-assurance",
  orderTracking: "/order-tracking",
  orderComponents: "/statistics",
  orders: "/statistics/orders",
  results: "/statistics/results",
  v3Reports: "/v3-reports",
  auditLogs: "/audit-logs",
  singleAuditLog: "/audit-log",
  errorLogs: "/illustration-logs",
  errorReports: "/illustration-log-reports",
  reroutedReports: "/rerouted-reports",
  missingPathologies: "/missing-pathologies",
  missingPathologyDetailLogs: "/missing-pathology-detail-logs",
  errorCodes: "/error-codes",
  playground: "/playground",
  newLogs: "/new-logs",
  educationalVideos: "/educational-videos/:uuid",
  videoLogs: "/video-logs",
  customerFeedback: "/customer-feedback",
})

export default routePaths
